import { render, staticRenderFns } from "./AppStackedIcons.vue?vue&type=template&id=66e5c4a6&"
import script from "./AppStackedIcons.vue?vue&type=script&lang=js&"
export * from "./AppStackedIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports